export default __webpack_public_path__ + "static/media/Mexi Salad Bowl - proportioned_170.fb1ec55c.jpg";